// TODO: import to this file is deprecated!
import Thead from "../../../Table/Thead";
import Tbody from "../../../Table/Tbody";
import Tr from "../../../Table/Tr";
import Th from "../../../Table/Th";
import Td from "../../../Table/Td";
import TableResponsiveWrapper from "../../../Table/ResponsiveWrapper";

export { default } from "../../../Table";

export { Thead, Tbody, Tr, Th, Td, TableResponsiveWrapper };
